Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "ShareButton161497603",
  {"root":"ShareButton161497603--root"},
  "",
  8,
  "ShareButton161497603"
);

